import { useCallback, useMemo, useState } from 'react';
import type {
  BiomarkerSelection,
  IBiomarkerData,
} from '@/types/PatientDashboard/PatientTimeline.types';
import { reconcileBiomarkerSelection } from '@/components/PatientDashboard/TimelineTab/Timeline/Biomarker.util';

interface IBiomarkerSelectionState {
  selection: BiomarkerSelection;
  toggleVariant: (variantId: string) => void;
}

export function useBiomarkerSelection(data: IBiomarkerData): IBiomarkerSelectionState {
  const [overrides, setOverrides] = useState<BiomarkerSelection>({});

  const selection = useMemo(
    () => reconcileBiomarkerSelection(data, overrides),
    [data, overrides],
  );

  const toggleVariant = useCallback((variantId: string): void => {
    setOverrides((previous) => ({ ...previous, [variantId]: !(previous[variantId] ?? true) }));
  }, []);

  return { selection, toggleVariant };
}
